module.exports = __webpack_public_path__ + "img/product-after-sale-finish-bg-icon.5d9af367.png";